import { z } from 'zod';

import { BlockValueStringSchema } from './blockValueStringSchema.js';
interface BlockValueUuidSchemaArgs {
  isRequired?: boolean;
}

/**
 * @arg isRequired - if isRequired is false, the empty string is allowed. Chain the schema with .optional() if
 * the entire config property is optional.
 * @returns A Zod schema for validating values that are either block value templates or UUID
 */
export function BlockValueUuidSchema(args: BlockValueUuidSchemaArgs) {
  const { isRequired = false } = args;
  const blockValueOrUuidSchema = BlockValueStringSchema({
    stringValidationSchema: z.string().uuid({ message: 'Must be a valid ID.' }),
  });
  if (isRequired) {
    return blockValueOrUuidSchema;
  }
  return z.union([z.literal(''), blockValueOrUuidSchema]);
}
